import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { AgGridReact } from "ag-grid-react";
import { teacherfilter, teacherlist } from "../../../services/teacher";
import Select from "react-select";
import { academylist } from "../../../services/admin";
import { toast } from "react-toastify";

export default function Allteachers() {
  const [studata, setStudata] = useState([]);
  const [urllink, setUrllink] = useState("");

  const [aclist, setACList] = useState([]);
  const [acaid, setAcaID] = useState("");
  const [teaid, setTeaId] = useState("");
  const [tealist, setTeaList] = useState([]);
  const navigate = useNavigate();
  const columnDefs = [
    {
      headerName: "Actions",
      width: 100,
      field: "id",
      resizable: true,
      filter: false,
      cellRenderer: function (params) {
        return (
          <div className="text-center">
            <a
              onClick={() => navigate(`/teacher/teacherdetail/${params.value}`)}
              className="btn-sm btn-info me-2"
            >
              <i className="fa fa-edit"></i>
            </a>
            <a
              onClick={() => navigate(`/teacher/profile/${params.value}`)}
              className="btn-sm btn-success"
            >
              <i className="fa fa-user"></i>
            </a>
          </div>
        );
      },
    },
    {
      headerName: "Photo",
      width: 100,
      field: "photo",
      resizable: true,
      filter: false,
      cellRenderer: function (params) {
        if(params.value !== null){
          return (
            <div className="text-center">
              <img
                src={params.data.path + params.value}
                onError={(ev) => errorphoto(ev)}
                style={{ height: "60px", width: "60px" }}
              />
            </div>
          );
        }else{
          return (
            <div className="text-center">
              <img
                src={require("../../../assets/images/user.png")}
                style={{ height: "60px", width: "60px" }}
              />
            </div>
          );
        }
       
      },
    },
    {
      headerName: "Teacher",
      field: "teacher_name",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Username",
      field: "username",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Mobile",
      field: "phone",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Incharge Class",
      field: "class_name",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Section",
      field: "section_name",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Qualification",
      field: "qual_name",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Academy",
      field: "academy_name",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
  ];

  const columnTDefs = [
    {
      headerName: "Photo",
      width: 100,
      field: "photo",
      resizable: true,
      filter: false,
      cellRenderer: function (params) {
        if(params.value !== null){
          return (
            <div className="text-center">
              <img
                src={params.data.path + params.value}
                onError={(ev) => errorphoto(ev)}
                style={{ height: "60px", width: "60px" }}
              />
            </div>
          );
        }else{
          return (
            <div className="text-center">
              <img
                src={require("../../../assets/images/user.png")}
                style={{ height: "60px", width: "60px" }}
              />
            </div>
          );
        }
       
      },
    },
    {
      headerName: "Teacher",
      field: "teacher_name",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Username",
      field: "username",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Mobile",
      field: "phone",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Incharge Class",
      field: "class_name",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Section",
      field: "section_name",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Qualification",
      field: "qual_name",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Academy",
      field: "academy_name",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
  ];

  function errorphoto(ev) {
    ev.target.src = require("../../../assets/images/teacher.jpg");
    ev.target.onerror = null;
  }
  const location = useLocation();
  useEffect(() => {
    const path = location.pathname.split("/")[2]; // Extracts 'allteacher' or 'leftteacherlist'
    setUrllink(path);
    if (path === "allteacher") {
      teacherlist(1).then((res) => {
        if (res.status === true) {
          setStudata(res.data.details);
        }
      });
    } else if (path === "leftteacherlist") {
      teacherlist(2).then((res) => {
        if (res.status === true) {
          setStudata(res.data.details);
        }
      });
    } else if (path === "deleteteacherlist") {
      teacherlist(3).then((res) => {
        if (res.status === true) {
          setStudata(res.data.details);
        }
      });
    } else if (path === "teacherreport") {

      academylist().then((res) => {
        if (res.status === true) {
          let arr = [];
          if (res.data.details.length > 0) {
            for (let i = 0; i < res.data.details.length; i++) {
              arr.push({
                value: res.data.details[i].id,
                label:
                  res.data.details[i].name + " - " + res.data.details[i].code,
              });
            }
            setACList(arr);
          }
        }
      });
      if (localStorage.getItem("AAcademy") != null) {
        academylist().then((res) => {
          if (res.status === true) {
            let arr = [];
            if (res.data.details.length > 0) {
              for (let i = 0; i < res.data.details.length; i++) {
                if (res.data.details[i].id == localStorage.getItem("AAcademy")) {
                  arr.push({
                    value: res.data.details[i].id,
                    label:
                      res.data.details[i].name + " - " + res.data.details[i].code,
                  });
                }
                if (arr.length > 0) {
                  setAcaID(arr[0]);
                  filterstu(arr[0],"");
                  
                }
              }
             
            }
          }
        });
      }else{
        filterstu('', '');
      }

      // teacherlist(1).then((res) => {
      //   if (res.status === true) {
      //     setStudata(res.data.details);
      //   }
      // });
      // filterstu('', '');
    }
  }, [location.pathname]);

  function handleAcademy(e) {
    setTeaId('');

    if (e !== null) {
      setAcaID(e);
      filterstu(e, teaid);
    } else {
      setAcaID("");
      filterstu('', teaid);
    }
  }

  function handleStu(e) {
    if (e !== null) {
      setTeaId(e);
      filterstu(acaid, e);

    } else {
      setTeaId("");
      filterstu(acaid, '');

    }
  }


  function filterstu(aca, stu) {
    setTeaList([]);
    const temp = new FormData();
    if (localStorage.getItem("Role") === "1" && aca !== "") {
      temp.append("academy", aca.value);
    }else if(localStorage.getItem("Role") !== "1"){
        temp.append("academy", localStorage.getItem("academy"));
    }
    temp.append("teacher_id", stu ? stu.value : '');

    teacherfilter(temp).then((res) => {
      if (res.status === true) {
        let arr = [];
        setStudata(res.data.details);
        if (res.data.details.length > 0) {
          for (let i = 0; i < res.data.details.length; i++) {
            arr.push({
              value: res.data.details[i].id,
              label:
                res.data.details[i].username +
                " - " +
                res.data.details[i].teacher_name,
            });
          }
        }
        setTeaList(arr);

      }
    });
  }

  function submitrep(e) {
    e.preventDefault();
    let valid = "";
    if (localStorage.getItem("Role") === "1") {
        if (acaid === "") {
            valid = "Please Select Academy";
            toast.error(valid);
            return
        }
    }
    let stu = teaid ? teaid.value : ''
    let aca = ''
    if (localStorage.getItem("Role") === "1" && acaid !== "") {
        aca = acaid.value
    }else if(localStorage.getItem("Role") !== "1"){
      aca = localStorage.getItem("academy")
  }
  const reportUrl = localStorage.getItem("reportUrl");
    window.open(reportUrl + 'report/teacherreport?academy_id=' + aca + '&teacher_id=' + stu , "_blank");
  }
  return (
    <div>
      <div className="page-header">
        {urllink === "allteacher" && (
          <>
            <h2 className="main-content-title tx-24 mg-b-5">All Teacher</h2>
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <a>Teacher</a>
              </li>
              <li className="breadcrumb-item active" aria-current="page">
                All Teacher
              </li>
            </ol>
          </>
        )}

        {urllink === "leftteacherlist" && (
          <>
            <h2 className="main-content-title tx-24 mg-b-5">Left Teacher</h2>
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <a>Teacher</a>
              </li>
              <li className="breadcrumb-item active" aria-current="page">
                Left Teacher
              </li>
            </ol>
          </>
        )}

        {urllink === "deleteteacherlist" && (
          <>
            <h2 className="main-content-title tx-24 mg-b-5">Delete Teacher</h2>
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <a>Teacher</a>
              </li>
              <li className="breadcrumb-item active" aria-current="page">
                Delete Teacher
              </li>
            </ol>
          </>
        )}
        {urllink === "teacherreport" && (
          <>
            <h2 className="main-content-title tx-24 mg-b-5">Teacher Report</h2>
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <a>Reports</a>
              </li>
              <li className="breadcrumb-item active" aria-current="page">
                Teacher Report
              </li>
            </ol>
          </>
        )}
      </div>
      <div className="content-body">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-12">
              <div className="card custom-card mg-b-20">
                <div className="card-body">
                  {urllink === "leftteacherlist" && (
                    <div className="text-right">
                      <Link to="/teacher/leftteacher" className="btn btn-success">
                        Add Left Teacher
                      </Link>
                    </div>
                  )}
                  {urllink === "deleteteacherlist" && (
                    <div className="text-right">
                      <Link to="/teacher/deleteteacher" className="btn btn-success">
                        Add Delete Teacher
                      </Link>
                    </div>
                  )}

                  {urllink === "teacherreport" &&
                    <div className="row">
                      {localStorage.getItem("Role") === "1" && (
                        <div className="col-xl-4 col-sm-6">
                          <div className="mb-3">
                            <label className="form-label">
                              Select Academy <span className="text-danger"> *</span>
                            </label>
                            <Select
                              className="default-select"
                              placeholder="Select Academy"
                              value={acaid}
                              options={aclist}
                              onChange={handleAcademy}
                              isSearchable={true}
                              isClearable
                              hidden
                            />

                          </div>
                        </div>
                      )}
                      <div className="col-xl-4 col-sm-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Teacher
                            <span className="text-danger"> *</span>
                          </label>
                          <Select
                            className="default-select"
                            placeholder="Select Teacher"
                            value={teaid}
                            options={tealist}
                            onChange={handleStu}
                            isSearchable={true}
                            isClearable
                            hidden
                          />
                        </div>
                      </div>
                      <div className="col-xl-4 col-sm-6">
                        <div className="res-right mt-5">
                          <button className="btn btn-success me-2" onClick={submitrep}>
                            Excel Download
                          </button>

                        </div>
                      </div>
                    </div>}

                  <div className="ag-theme-alpine ag-style mt-2">
                    <AgGridReact
                      columnDefs={urllink === "teacherreport"  ? columnTDefs : columnDefs}
                      rowData={studata}
                      pagination="true"
                      paginationPageSize="10"
                      sortingOrder={["asc", "desc"]}
                      suppressDragLeaveHidesColumns={true}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
